import { AfterViewInit, Component, EventEmitter, inject, Input, Output, ViewChild } from '@angular/core';
import { TrialSupportContact } from "../../../../../../core/models/trial-detail.model";
import { FormControl, FormGroup } from "@angular/forms";
import { Permissions } from "../../../../../../core/constants/permissions";
import { AuthService } from "../../../../../../core/services/auth.service";
import {
  AutosuggestDropdownInputComponent
} from "../../../../../../shared/autosuggest-dropdown-input/autosuggest-dropdown-input.component";

@Component({
  selector: '[trial-contacts-table-row]',
  templateUrl: './trial-contacts-table-row.component.html',
  styleUrl: './trial-contacts-table-row.component.scss'
})
export class TrialContactsTableRowComponent implements AfterViewInit {
  protected readonly authService = inject(AuthService);

  @ViewChild('countrySelect') countrySelect: AutosuggestDropdownInputComponent;

  @Output() removed = new EventEmitter();
  @Output() countryUpdated = new EventEmitter<string>();
  @Output() labelUpdated = new EventEmitter<string>();
  @Output() cultureUpdated = new EventEmitter<string>();
  @Output() contactUpdated = new EventEmitter<string>();

  @Input() contact: TrialSupportContact;
  @Input() countryList: { text: string, value: string }[] = [];
  @Input() cultures: { text: string, value: string }[] = [];

  protected readonly form = new FormGroup({
    country: new FormControl<string>(''),
  });

  protected readonly Permissions = Permissions;

  ngAfterViewInit(): void {
    if (this.contact && this.contact.country) {
      // Apply a delay to allow the country list to be applies to the dropdown before setting the value
      setTimeout(() => {
        this.form.get('country').setValue(this.contact.country);
      }, 200);

      // Set option in the dropdown (deferred to avoid ExpressionChangedAfterChecked)
      Promise.resolve().then(() => {
        const option = this.countrySelect.options.find(o => o.value === this.contact.country);
        if (option) {
          this.countrySelect.selectOption(option);
        }
      });
    }

    this.form.get('country').valueChanges.subscribe(country => {
      this.countryUpdated.emit(country);
    });
  }

  inputValue(event: Event) {
    const element = event.target as HTMLInputElement;
    return element.value;
  }
}
